import * as React from "react";

const SvgAlertCircle = (props) => (
  <svg
    className="alert-circle_svg__bi alert-circle_svg__bi-alert-circle"
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0 1a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      clipRule="evenodd"
    />
    <path d="M9.002 13a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM9.1 6.995a.905.905 0 1 1 1.8 0l-.35 3.507a.553.553 0 0 1-1.1 0L9.1 6.995z" />
  </svg>
);

export default SvgAlertCircle;
